@if (active) {
  <div class="progress-bar">
    <div class="slider"></div>
  </div>
}
